import React, { useState } from 'react'
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../Modal/modal'
import ListKeyWords from '../ListKeyWords/ListKeyWords';
import './AddUnit.css'
import {Grid, Button, TextField } from '@mui/material';
import axios from "axios";
import { URL } from '../../constants/constant';

const AddUnit = ({selectedRows, setOpen, setMessage, newUnit, setNewUnit, units, setUnits, getTableData}) => {
    const [showModal, setShowModal] = useState(false);

    const modalButtonClick = () => {
        if (selectedRows.length <= 0) {
            setOpen(true)
            setMessage('Please select a Package first')
            return
        }
        setShowModal(true)
    }

    const closeModal = () => {
        setUnits([])
        setNewUnit('')
        setShowModal(false)
    }

    const addUnit = () => {

        if (newUnit.includes(',')) {
            setOpen(true)
            setMessage('Unit cannot contain comma (,)')
            return
        }

        if (units.indexOf(newUnit) !== -1){
            setOpen(true)
            setMessage('Unit is already added')
            return
        }

        if (newUnit === '') {
            setOpen(true)
            setMessage('Please enter some text before adding')
            return
        }

        let listUnit = selectedRows[0].units
        listUnit = listUnit.split(', ')
        if (listUnit.indexOf(newUnit) !== -1) {
            setOpen(true)
            setMessage('Unit is already present in the knowledge base')
            return
        }

        setUnits([...units,newUnit.trim()])
        setNewUnit('')
    }

    const removeUnit = (keyName) => {
        setUnits(units.filter((key) => key !== keyName));
    }

    const addUnitAPI = () => {
        if (units.length === 0) {
            setOpen(true)
            setMessage('Please add a unit first before saving')
            return
        }
        const unitsConcat = units.join(',')
        const user = JSON.parse(localStorage.getItem("loggedInUserDetails")).emailId;

        const data = JSON.stringify({
            "subtest_name" : selectedRows[0].subtest_name,
            "newUnits": unitsConcat,
            "user": user
        });
        
        var config = {
            method: 'post',
            url: URL.demystify_url + 'knowledgeBase/addUnits',
            headers: { 
            'Content-Type': 'application/json'
            },
            data : data
        };

        axios(config)
        .then(function (response) {
            if(response.data.success === 1){
                setOpen(true); 
                setMessage("Units added succesfully"); 
                getTableData();
            }
            else if(response.data.success === 0){
                setOpen(false); 
                setMessage(response.data.errorMessage);
            }
        })
        .catch(function (error) {
            alert("Something went wrong, please try again")
            console.log(error);
        });

        closeModal()
    }

    return (
        <Grid>
            <div className='add-keyword'>
                <Button variant='contained' onClick={modalButtonClick}>
                    Add Unit
                </Button>
            </div>

            <div>
                <Modal show={showModal} setShow={setShowModal}>
                    <ModalHeader className='modal-header'>
                        <h2>Add Unit</h2>
                    </ModalHeader>
                    <ModalBody>
                        <div className='subtest-name' >
                            <div className='new-unit' style={{justifyContent:'center'}}>
                                <h3 style={{textAlign:'center',fontWeight:'bold'}}>Sub Test Name :<span>{selectedRows.length>0 ? selectedRows[0].subtest_name:undefined}</span></h3>
                            </div>
                        </div>
                        <div className='new-unit'>
                            <TextField
                                rows={1}
                                autoComplete='off'
                                value={newUnit}
                                onChange={ (e) => {
                                    setNewUnit(e.target.value);
                                }}
                                variant='outlined'
                                label = 'Unit' 
                                style={{width:300}}
                                className='new-unit'
                                InputProps={{endAdornment: <Button variant='contained' onClick={addUnit} type="submit">Add</Button>}}
                            />
                        </div>
                        <ListKeyWords keyWords={units} removeTest={removeUnit}/>
                    </ModalBody>

                    <ModalFooter>
                        <Button variant="contained" style={{marginRight: 50}} onClick={addUnitAPI}>Save</Button>
                        <Button onClick={closeModal} variant="outlined">
                            Close
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        </Grid>
    )
}

export default AddUnit